import * as React from 'react';
import useRootHook from './hooks/useRoot'
import {Routes, Route, useSearchParams, Navigate} from "react-router-dom";

import Login, {TYPE_ADMIN, TYPE_KEY, TYPE_REFERRAL} from "./components/Login";
import {useEffect, useState} from "react";

import Main from "./components/Main";
import Loader from './components/Loader'
import ForgotPassword from "./components/ForgotPassword";
import Notification from "./components/Notification";
import ErrorDialog from "./components/ErrorDialog";
import ConfirmDialog from "./components/ConfirmDialog";
import Payment from "./components/Payment"
import PaymentStatusReturn from "./components/PaymentStatusReturn"
import merchants from "./models/merchants";
import referrals from "./models/referrals";
import admins from "./models/admins";
import request from "./helpers/request";

export default function App() {
    const { 
        authed, setAuthed, userData, setUserData, setShowLoader, setDefaultCurrency, setForcedMerchant,
        showErrorDialog, setShowErrorDialog, errorDialogTitle, errorDialogMessage, showError,
        showConfirmDialog, setShowConfirmDialog, confirmDialogTitle, confirmDialogMessage, handleConfirmDialogClose
    } = useRootHook();
    const [isInited, setIsInited] = useState(false)
    const [searchParams] = useSearchParams()

    // Set global error handler for request.js
    React.useEffect(() => {
        request.setErrorHandler(showError);
    }, [showError]);

    useEffect(() => {
        setShowLoader(true)
        if (window.location.protocol !== 'https:' && process.env.NODE_ENV !== 'development') {
            //window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`)
            //return
        }
        
        // Use /init endpoint which works for all user types
        const initParams = searchParams.has('force_merchant_id') ? { force_merchant_id: searchParams.get('force_merchant_id') } : {};
        request.get('/init', initParams).then((data) => {
            setShowLoader(false)
            data && data.username && setAuthed(true)
            data && data.username && setUserData(data)
            data && data.defaultCurrency && setDefaultCurrency(data.defaultCurrency)

            //we set here the userData because getting it from the hook may result in old or null data since hooks are async
            searchParams.has('force_merchant_id') && setForcedMerchant(searchParams.get('force_merchant_id'), data)

            setIsInited(true)
        }).catch(() => setShowLoader(false))
    }, [])

    if (!isInited) return null

    return <React.Fragment>
        <Routes>
            <Route path="/login/*" element={<Login />} />
            <Route path="/forgot-password/*" element={<ForgotPassword />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/status/:outcome" element={<PaymentStatusReturn />} />
            <Route path="/*" element={authed ? <Main /> : <Navigate replace to={
                localStorage.getItem(TYPE_KEY) === TYPE_ADMIN ? '/login/admin' : 
                localStorage.getItem(TYPE_KEY) === TYPE_REFERRAL ? '/login/referral' : 
                '/login'
            } />} />
        </Routes>
        <Loader />
        <Notification />
        <ErrorDialog 
            open={showErrorDialog}
            onClose={() => setShowErrorDialog(false)}
            title={errorDialogTitle}
            message={errorDialogMessage}
        />
        <ConfirmDialog
            confirmOpen={showConfirmDialog}
            setConfirmOpen={(open) => {
                if (!open) {
                    handleConfirmDialogClose(false);
                } else {
                    setShowConfirmDialog(true);
                }
            }}
            title={confirmDialogTitle}
            onConfirm={() => handleConfirmDialogClose(true)}
        >
            {confirmDialogMessage}
        </ConfirmDialog>
    </React.Fragment>
}

